import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Assests/Scss/Scenario.scss";
import Loading from "../../../../Student/Reusablecomponents/Loading";

import Search from "../../../../ReusableComponents/Search";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
import { useSelector, useDispatch } from "react-redux";
import ScenarioQuestionformat from "../../../../Student/Reusablecomponents/ScenarioQuestionformat";
import { useNavigate, useLocation } from "react-router-dom";
import { ScenarioData } from "../../../../Redux/Reducers/QBAdmin/Editscenario";
import notify from "../../../../ReusableComponents/ToastifyAlerts";
import ScenarioDelete from "../../../../ReusableComponents/CommonApis";
import { GetEnglishScenarioDetails } from "../../../../ReusableComponents/CommonApis";
import { GetQuestionByScenario } from "../../../../ReusableComponents/QBAdmin/QBACommonApi";
import { QuestionPreview, GetEnglishQuestionDetails } from "../../../../ReusableComponents/CommonApis";
const EScenario = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const SelectLanguage = useSelector((state) => state.SelectLanguageData.SLanguage);

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const PNumber = PagnatioNumber?.Location === location.pathname && PagnatioNumber?.PageNumber;

  const [SearchSelection, SetSearchSelection] = useState(localStorage.getItem("FilterSelection") || "By Scenario Id(s)");
  const [SearchText, SetSearchText] = useState(localStorage.getItem("SearchSId") || "");
  const [ScenarioList, SetScenarioList] = useState(props.data);
  const [SelectFilters, SetSelectFilters] = useState(JSON.parse(localStorage.getItem("ByStatus")));
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(PNumber || 1);
  const [Load, SetLoad] = useState(false);

  const handleFilterChange = (filter) => {
    if (SelectFilters.includes(filter)) {
      SetSelectFilters(SelectFilters.filter((f) => f !== filter));
    } else {
      SetSelectFilters([...SelectFilters, filter]);
    }
  };

  const ScenariosBySubject = async (PageNo, CStatus) => {
    SetCPage(PageNo);
    SetLoad((prev) => !prev);
    await axios.get(process.env.REACT_APP_API_BASE_URL +
      `/Scenario/GetLanguageScenarios?SubjectId=${items?.subjectId
      }&PageNo=${PageNo}&PageSize=${PageCount}&IsUsedOrMapped=${SelectFilters?.join(",") || 0
      }&QBCategoryType=SCQ`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
      .then((res) => {
        if (res.data[0]?.scenarioID) { SetScenarioList(res.data); }
        else { SetScenarioList(process.env.REACT_APP_NODATAFOUND); }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (SearchText?.length > 0 && SearchSelection === "By Question Id(s)") { GetQuestionByScenario(SearchText, items?.subjectId, 0, SetScenarioList, SetLoad); }
    if (SearchText?.length > 0 && SearchSelection === "By Scenario Id(s)") { SearchById(); }
    else if (!props.data && SearchText?.length === 0) { ScenariosBySubject(CPage); }
  }, [PageCount]);

  const SearchById = async () => {
    SetLoad((prev) => !prev);
    await axios.get(process.env.REACT_APP_API_BASE_URL +
      `/Scenario/GetScenarioByIds?SubjectId=${items?.subjectId}&ScenarioId=${SearchText}&LanguageId=${SelectLanguage}`,
      { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
    )
      .then((res) => {
        if (res.data[0]?.scenarioID) {
          SetScenarioList(res.data);
        } else { SetScenarioList(process.env.REACT_APP_NODATAFOUND); }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        SetLoad((prev) => !prev);
        notify("Please enter valid input", "warning");
      });
  };

  const GetFilterData = () => {
    if(SearchSelection !== "By Status" && SearchText?.length > 0 && SearchText.split(",").length > 20){
  notify("You can enter a maximum of 20 IDs only.", "warning");
  return
}
    localStorage.setItem("FilterSelection", SearchSelection);
    if (SearchText?.length > 0 || SelectFilters?.length > 0) {
      if (SearchText?.length > 0) {
        if (SearchText?.length > 0 && SearchSelection === "By Question Id(s)") { GetQuestionByScenario(SearchText, items?.subjectId, 0, SetScenarioList, SetLoad); }
        if (SearchSelection === "By Scenario Id(s)") { SearchById(); }
      }
      else {
        localStorage.setItem("ByStatus", JSON.stringify(SelectFilters));
        ScenariosBySubject(1);
      }
    } else {
      notify(`${SearchSelection === "By Scenario Id(s)"
        ? "Please enter the Scenario Id to click Go button"
        : SearchSelection === "By Question Id(s)" ?
          "Please enter the Question Id to click Go button" : "Please select atlest one Status"
        }`, "warning");
    }
  };
  const BacktoNormaList = () => {
    if (SearchSelection === "By Question Id(s)") {
      SetSearchSelection("By Scenario Id(s)");
    }
    localStorage.removeItem("ByStatus");
    localStorage.removeItem("SearchSId");
    SetSearchText([]);
    SetSelectFilters([]);
    ScenariosBySubject(1, "0");
    localStorage.removeItem("FilterSelection");
  };
  const QuestionBased = [
    { name:"Scenario No(Id)",selector: "scenarioId", sortable: true,},
    {
      name: "Question No(Id)", selector: "questionID", sortable: true,
      cell: (row) => (
        <div className="LinkStyles" title="Edit Question" onClick={() => HandleQuestionDetails(row.questionID)} > {row.questionID} </div>),
    },
    {
      name: "Question", selector: "question",
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.question} />
          {row.qType !== "D" &&
            ["A", "B", "C", "D"].map((option, i) => (
              <div key={i} className="Options" style={option === row.answer ? { color: "green", fontWeight: "bold" } : {}} >
                <span className="dflex p-1"> {option})&nbsp; <ScenarioQuestionformat scenario={row[`option${option}`]} /> </span>
              </div>
            ))}
        </div>
      ),
    },
    {
      name: "Answer(s)", selector: "answer", sortable: true,
      cell: (row) => (<span className="dflex p-1"> {row.answer}) &nbsp; <ScenarioQuestionformat scenario={row[`option${row.answer}`]} /> </span>),
    },
    {
      name: "Question Verification Status", selector: "qbStatus", sortable: true,
      cell: (row) => (
        <div className="dflex flexd-column"> <span>{row.qbStatus}</span>
          {/* <span className="LinkStyles" style={{ textWrap: "nowrap" }} onClick={() => SetStatusData(row.questionID)} > View Status Log </span> */}
        </div>
      ),
    },
    { name: "Used/Unused - Mapped/UnMapped", selector: "qStatus", sortable: true, },
    {
      name: "Action",
      cell: (row) => (
        <div className="dflex CPointer alignitems JCCenter gap-2" >
          <FaRegEye title="Preview"
            onClick={() => {
              localStorage.setItem("SearchSId", SearchText);
              QuestionPreview(row, dispatch, navigate, location, true)
            }} />
          {/* <RiDeleteBin5Line style={{ color: "#FD3333" }}
            onClick={() => QuestionDelete(row.questionID, SetDMessage, dispatch, location) } /> */}
          {/* <span className="LinkStyles" style={{ textWrap: "nowrap" }}
            onClick={() => SetQuestionData(row.questionID)} title="View Question Activity Log" >
            <FaClockRotateLeft /> </span> */}
        </div>
      ),
    },
  ];
  const HandleQuestionDetails = (Qid) => {
    navigate(".", { state: { ...location.state, SList: CPage } });
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchSid", SearchText);
    }
    GetEnglishQuestionDetails(Qid, dispatch, navigate, SetLoad, location, true);
  };
  const columns = [
    {
      name: "Scenario ID", selector: "scenarioID", sortable: true,
      cell: (row) => (<div className="LinkStyles" onClick={() => AddEditScenario(row)} title="Edit Scenario"> {row.scenarioID} </div>),
    },
    {
      name: "Scenario", selector: "scenarioName", sortable: true,
      cell: (row) => (<div className="ScenarioList"> <ScenarioQuestionformat scenario={row.scenarioName} /> </div>),
    },
    {
      name: "Main Source", selector: "mainSourceLovId", sortable: true,
      cell: (row) => (<div> {row.mainSourceLovId === 3543 ? "Text book based" : "Non-text book based"} </div>),
    },
    {
      name: "Questions",
      cell: (row) => (
        <div className="dflex alignitems gap-3 JCCenter">
          <div className=" dflex alignitems gap-1">
            <FaRegEye className="CPointer" title="View Questions in Scenario"
              onClick={() => NavigateQuestions(row)} style={{ color: "#624DE3" }} /> ({row.questionCount})
          </div>
          <RiDeleteBin5Line className="CPointer" style={{ color: "#FD3333" }} onClick={() => DeleteScenario(row)} />
        </div>
      ),
    },
  ];
  const DeleteScenario = async (Row) => {
    if (Row.questionCount > 0) {
      alert("Please delete all questions associated with the scenario before you could delete the scenario");
    } else {
      if (window.confirm("Are you sure you want to delete the scenario ?")) {
        ScenarioDelete(Row.scenarioID, dispatch, location, ScenariosBySubject(1));
      }
    }
  };
  const NavigateQuestions = (Row) => {
    dispatch(ScenarioData({ ScenarioDetails: Row }));
    if (JSON.parse(localStorage.getItem("LoFilters"))) {
      navigate("/QBAdmin/QuestionBank/FilterScenarioQuestions", { state: { Tab: location.state?.Tab, SID: Row?.scenarioID }, });
    } else { navigate("/QBAdmin/QuestionBank/ScenarioQuestions", { state: { Tab: location.state?.Tab }, }); }
  };

  const AddEditScenario = (Row) => {
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchSId", SearchText);
    }
    GetEnglishScenarioDetails(Row.scenarioID, dispatch, navigate, SetLoad, location, true);
  };

  const ChangeFilter = (Search) => {
    if (Search !== "By Question Id(s)") {
      ScenariosBySubject(CPage);
    }
    SetSearchText([]);
    SetSelectFilters([]);
    SetSearchSelection(Search);
     localStorage.removeItem("FilterSelection");
  };
  return (
    <>
      {!props.data && (
        <>
          <div className="MainHeading">Scenario based Questions</div>
          <div className="Card mt-2">
            <div className="dflex JSBetween alignitems InputFIlters m-1">
              <label style={{ backgroundColor: "white" }}>Search</label>

              <div className="dflex" style={{ gap: "15px" }}>
                {["By Scenario Id(s)", "By Question Id(s)", "By Status"].map((element) => (
                  <span className="dflex alignitems gap-2" >
                    <input type="radio" name="Search" value={element} checked={element == SearchSelection}
                      onChange={() => { ChangeFilter(element); }} /> {element} </span>
                ))}
              </div>

              {SearchSelection !== "By Status" ? (
                <div style={{ position: "relative", right: "100px" }}>
                  <Search onChange={(e) => SetSearchText(e.replace(/[^0-9,]/g, ""))} Searchvalue={SearchText}
                    placeholder={`Enter ${SearchSelection === "By Scenario Id(s)" ? "Scenarios" : "Question"} Id(s)`} />
                </div>
              ) : (
                <div className="dflex p-2 QBFStuats">
                  {["Used", "Unused", "Mapped", "Unmapped", "NA"].map((Filter) => (
                    <div className="dflex alignitems gap-2" key={Filter} onChange={() => handleFilterChange(Filter)} >
                      <input type="checkbox" value={Filter} checked={SelectFilters.includes(Filter)} /> {Filter}{" "}
                    </div>)
                  )}
                </div>
              )}

              <div className="dflex alignitems gap-2" >
                <button className="Buttons" onClick={()=>GetFilterData()}> Go </button>
                <button className="Buttons" onClick={()=>BacktoNormaList()} >
                  {SearchSelection === "By Question Id(s)" ? "Back to scenario" : "Clear Filters"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="dflex mt-3 alignitems JSBetween">
        <div className="SubHeading">{SearchSelection === "By Question Id(s)" ? "Questions" : "Scenarios"} </div>
        {props.data ? (<div></div>) : (
          <button className="Buttons AddButton dflex alignitems JCCenter"
            onClick={() => {
              navigate("/QBAdmin/QuestionBank/AddEditScenario");
              dispatch(ScenarioData({ ScenarioDetails: "" }));
            }} > <HiMiniPlusSmall /> Add Scenario </button>
        )}
      </div>
      <div className="Card mt-2">
        {ScenarioList?.[0]?.scenarioID || ScenarioList?.[0]?.questionID ? (
          <DataTable data={ScenarioList} className="NCLDataTable" GetCurrentPage={SetCPage}  
          // CCpage = {CPage}
            columns={SearchSelection === "By Question Id(s)" ? QuestionBased : columns}
            TotalRecords={props.data ? "" : ScenarioList[0]?.totalScenario || ScenarioList?.length}
            CountPage={SetPageCount} NoPage={props.data ? "" : CPage}
            ShowPagination={true} ShowPagecount={true}
            Dropdownvalues={["10", "25", "50", "100"]}
            hitapi={props.data ? "" :SearchSelection !== "By Question Id(s)" && ScenariosBySubject} />
        ) : (<div className="ErrorMessage">{ScenarioList}</div>)}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default EScenario;